var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CElementCover',{staticClass:"custom-element-cover",attrs:{"boundaries":[{ sides: ['top', 'left'], query: '.media-body' }],"opacity":_vm.opacity,"center":true}},[_c('h1',{staticClass:"d-inline"},[_vm._v(_vm._s(_vm.loadingText))]),_c('CSpinner',{attrs:{"size":_vm.spinnerSize,"color":_vm.spinnerColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }